// extracted by mini-css-extract-plugin
export var notificationHost = "_l8-0";